export default __webpack_public_path__ + "static/media/8.38a2cc29.jpeg";